export default "__VITE_ASSET__D2KkNnE7__"